module.exports = __webpack_public_path__ + "img/icon-white-invoice.97355d49.png";